import { createReducer } from 'lib/utilities';

export const initialState = {
  loading: false,
  chatLoading: false,
  paginationLoading: false,
  metaMessageUniqueId: false,
  showActivityTimeline: false,
  chatOffset: 0,
  scrollToBottomOfChatWindow: false,
  nextechPaymentsLoading: false,
  draftFlag: false,
  showDraftSavedNotificaton: false,
  composerEmail: {
    showCcs: false,
    showBccs: false,
    contactId: undefined,
    contactDetailId: undefined,
    platformRegistrationId: undefined,
    subject: '',
    message: '',
    bccs: [],
    ccs: [],
    fileIds: [],
    showAdvanced: false,
    expandMessage: false,
    email_id: undefined,
    template: {
      subject: undefined,
      message: null,
      confirmed: false,
      visible: false,
    },
  },
  composerPhone: {
    manual: false,
    contactId: undefined,
    contactDetailId: undefined,
    fromId: undefined,
    platformRegistrationId: undefined,
    message: '',
    note: '',
    fileIds: [],
    autoSelect: true,
    template: {
      subject: undefined,
      message: null,
      confirmed: false,
      visible: false,
    },
  },
};

export default createReducer(initialState, {
  leadModalSetLoading: (state, bool) => ({ ...state, loading: bool }),
  leadModalSetChatLoading: (state, bool) => ({ ...state, chatLoading: bool }),
  leadModalSetShowActivityTimeline: (state, bool) => ({ ...state, showActivityTimeline: bool }),
  leadModalSetPaginationLoading: (state, bool) => ({ ...state, paginationLoading: bool }),
  leadModalSetChatOffset: (state, offset) => ({ ...state, chatOffset: offset }),
  leadModalSetMetaMessageUniqueId: (state, payload) => ({ ...state, metaMessageUniqueId: payload }),
  leadModalPatchComposerEmail: (state, payload = {}) => {
    return {
      ...state,
      composerEmail: { ...(state.composerEmail || {}), ...payload },
    };
  },
  POST_COMPOSER_MESSAGE_SUCCESS: (state, payload = {}) => {
    return {
      ...state,
      scrollToBottomOfChatWindow: true,
    };
  },
  setScrollToBottomOfChatWindow: (state, payload = {}) => {
    return {
      ...state,
      scrollToBottomOfChatWindow: true,
    };
  },
  POST_PHONE_CALL_SUCCESS: (state, payload = {}) => {
    return {
      ...state,
      scrollToBottomOfChatWindow: true,
    };
  },
  resetLeadModalScrollToBottomOfChatWindow: (state, payload = {}) => {
    return {
      ...state,
      scrollToBottomOfChatWindow: false,
    };
  },
  leadModalPatchComposerWithDraftEmail: (state, payload = {}) => {
    return {
      ...state,
      draftFlag: true,
      composerEmail: { ...(state.composerEmail || {}), ...payload },
    };
  },
  resetDraftFlag: (state, payload = {}) => {
    return {
      ...state,
      draftFlag: false,
    };
  },
  resetAssociatedDraftState: (state, payload = {}) => {
    return {
      ...state,
      draftFlag: false,
      composerEmail: { ...initialState.composerEmail },
    };
  },
  leadModalPatchComposerPhone: (state, payload = {}) => ({
    ...state,
    composerPhone: { ...(state.composerPhone || {}), ...payload },
  }),

  leadModalClearComposerEmailContent: (state, payload = {}) => ({
    ...state,
    composerEmail: {
      ...initialState.composerEmail,
      contactId: (state.composerEmail || {}).contactId,
      contactDetailId: (state.composerEmail || {}).contactDetailId,
      platformRegistrationId: (state.composerEmail || {}).platformRegistrationId,
    },
  }),
  leadModalPatchComposerEmailRemoveFileId: (state, payload = {}) => {
    const { attachment_id } = payload;
    const withFileIdRemoved = state.composerEmail.fileIds.filter((item) => item !== attachment_id);
    return {
      ...state,
      composerEmail: {
        ...state.composerEmail,
        fileIds: withFileIdRemoved,
      },
    };
  },
  POST_DRAFT_EMAIL_SUCCESS: (state, payload = {}) => {
    return {
      ...state,
      composerEmail: {
        ...state.composerEmail,
        email_id: payload.data.id,
      },
    };
  },
  RESET_COMPOSER_EMAIL: (state) => ({
    ...state,
    draftFlag: true,
    composerEmail: { ...initialState.composerEmail },
  }),
  RESET_COMPOSER_PHONE: (state) => ({
    ...state,
    composerPhone: { ...initialState.composerPhone },
  }),
  nextechPaymentsLoading: (state, payload) => ({
    ...state,
    nextechPaymentsLoading: payload,
  }),
  setDraftSavedNotification: (state, payload) => ({
    ...state,
    showDraftSavedNotificaton: payload,
  }),
});
